import L from 'leaflet';

window.L = L;
